import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Vault } from "@phosphor-icons/react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md animate-fade-in-up">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-11 w-11 rounded-md bg-primary flex items-center justify-center">
            <Vault size={24} weight="fill" className="text-primary-foreground" />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-semibold tracking-tight leading-none">BEYT KASA</h1>
            <p className="text-xs tracking-[0.2em] uppercase text-muted-foreground mt-1">Finans Yönetimi</p>
          </div>
        </div>

        <div className="bg-card border border-border rounded-lg p-8">
          <h2 className="font-heading text-xl mb-1">Tekrar hoş geldiniz</h2>
          <p className="text-sm text-muted-foreground mb-6">Hesabınıza giriş yapın</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-wide text-muted-foreground">E-posta</Label>
              <Input
                id="email" type="email" required data-testid="login-email"
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 bg-secondary border-border" placeholder="ornek@sirket.com"
              />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <Label htmlFor="password" className="text-xs uppercase tracking-wide text-muted-foreground">Şifre</Label>
                <Link to="/forgot-password" data-testid="forgot-link" className="text-xs text-primary hover:underline">
                  Şifremi unuttum
                </Link>
              </div>
              <Input
                id="password" type="password" required data-testid="login-password"
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 bg-secondary border-border" placeholder="••••••••"
              />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-medium">
              {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
